module.exports = __webpack_public_path__ + "static/img/dz-banner.d84558b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dz-banner.png
// module id = WIzy
// module chunks = 18